/**
 * @generated SignedSource<<87b9d3f3e2cbedf58c2d61b950bb4372>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LocationPractitioners_Practitioners",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Practitioner",
      "kind": "LinkedField",
      "name": "practitioner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerVersion",
          "kind": "LinkedField",
          "name": "applicableVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LegalContractLineOfService",
      "kind": "LinkedField",
      "name": "legalContractLineOfService",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LineOfService",
          "kind": "LinkedField",
          "name": "lineOfService",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PractitionerLocationVersion",
      "kind": "LinkedField",
      "name": "applicableVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showInDirectory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "acceptingNewPatients",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PractitionerLocation",
  "abstractKey": null
};
})();

node.hash = "4c9f6d58ead3e261973915214cdf8674";

export default node;
